import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pedido } from '../model/pedido';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {
  constructor(private http: HttpClient,
              public global: GlobalService) { }
  user = this.global.user;
  pass = this.global.pass;
  auth = btoa(this.user + ':' + this.pass);

  dominio = this.global.dominio;
  pedidoUrl = this.dominio + '/backend/api/v2/pedido';

  listarTodas(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/todos`, { headers })
      .toPromise();
  }


  setNaoImpresso(id): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/setNaoImpressoPorId/${id}`, { headers })
      .toPromise();
  }

  

  
  inserirPedidoJava(json): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(json);
    return this.http.post<any>(`${this.pedidoUrl}/inserirJava`, body, { headers })
      .toPromise();

  }

  
  mudarFechadoAtendente(id): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/mudarFechadoAtendente/${id}`, { headers })
      .toPromise();
  }
  
  getOrdens(token): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/getOrdens/${token}`, { headers })
      .toPromise();
  }


  temOrdemNoPedido(idPedido): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/temOrdemNoPedido/${idPedido}`, { headers })
      .toPromise();
  }

  getOrdem(idOrdem): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/getOrdem/${idOrdem}`, { headers })
      .toPromise();
  }


  setOrdemNaoImpressaPorId(idOrdem): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/setOrdemNaoImpressaPorId/${idOrdem}`, { headers })
      .toPromise();
  }
  

  

  getOrdensByPedido(idPedido): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/getOrdensByPedido/${idPedido}`, { headers })
      .toPromise();
  }
  

  getNaoImpressoJava(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    headers.set('Access-Control-Allow-Origin', '*');
    console.log(headers);
    return this.http.get(`http://34.201.39.208:8090/backend/api/v2/pedido/todosNaoImpressosNew/`, { headers })
      .toPromise();
  }





    getStatus(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${ this.dominio}/backend/api/v2/status/getStatusPorEmpresa`, { headers })
      .toPromise();
  }

  inserirStatus(id): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${ this.dominio}/backend/api/v2/status/inserirStatusEmpresa/${id}`, { headers })
      .toPromise();
  }

     excluirStatus(id): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${ this.dominio}/backend/api/v2/status/deletarStatusEmpresa/${id}`, { headers })
      .toPromise();
  }


  getTodosStatus(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${ this.dominio}/backend/api/v2/status/getStatus`, { headers })
      .toPromise();
  }

  getUltimos(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/pegarUltimos`, { headers })
      .toPromise();
  }


  getUltimosPorParam(param): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/pegarUltimosPorParametro/${param}`, { headers })
      .toPromise();
  }

  mudarStatus(pedido: Pedido, status): Promise<Pedido> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(pedido);
    return this.http.put(`${this.pedidoUrl}/mudarStatus/${status}`, body, { headers })
      .toPromise()
      .then(response => {
        const pessoaAlterada = response as Pedido;
        return pessoaAlterada;
      });
  }
  
  
  getDataeParamGerenciar(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GetDataeParamGerenciador/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }


  getDataeParamGerenciarEncomenda(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GetDataeParamGerenciadorEncomenda/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }


  


  GetDataeParamGerenciadorEncomendaDataPedido(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GetDataeParamGerenciadorEncomendaDataPedido/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }

  GetAbertosEncomenda(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GetAbertosEncomenda/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }


  GetSemDataEncomenda(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GetSemDataEncomendaByStts/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }


  

  GeraRelatorioCliente(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GeraRelatorioCliente/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }

  getRanking(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/gerarRankingProd/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }


  deletarVarios(ids, idcomanda): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/deletarVarios/${ids}/${idcomanda}`, { headers })
      .toPromise();
  }


  gerarLog(id, token, comanda, pedidos): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/gerarLog/${id}/${token}/${comanda}/${pedidos}`, { headers })
      .toPromise();
  }

  historicoConsumidor(data1, data2, status, id): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/historicoConsumidor/${data1}/${data2}/${status}/${id}`, { headers })
      .toPromise();
  }


  rankingVendas(data1, data2, status): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/rankingVendasAnalise/${data1}/${data2}/${status}`, { headers })
      .toPromise();
  }


  rankingOciosos(data1, data2, status): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/rankingOciosos/${data1}/${data2}/${status}`, { headers })
      .toPromise();
  }



  relatorioProd(data1, data2, status, tipo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/relatorioProd/${data1}/${data2}/${status}/${tipo}`, { headers })
      .toPromise();
  }


  relatorioEntregador(data1, data2, status, entregador): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/relatorioEntregador/${data1}/${data2}/${status}/${entregador}`, { headers })
      .toPromise();
  }


  rankingEntregador(data1, data2, status): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/gerarRankingEntregador/${data1}/${data2}/${status}`, { headers })
      .toPromise();
  }

  pegarFormasPagamento(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/pegarFormasPagamento`, { headers })
      .toPromise();
  }


  GerarControleCaixa(data1, data2, tipoPedido, formaPagamento): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GerarControleCaixa/${data1}/${data2}/${tipoPedido}/${formaPagamento}`, { headers })
      .toPromise();
  }

  
  GerarControleCaixaEncomenda(data1, data2, tipoPedido, formaPagamento): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GerarControleCaixaEncomenda/${data1}/${data2}/${tipoPedido}/${formaPagamento}`, { headers })
      .toPromise();
  }


  GerarControleCaixaGeral(data1, data2, tipoPedido): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GerarControleCaixaGeral/${data1}/${data2}/${tipoPedido}`, { headers })
      .toPromise();
  }

  GerarControleCaixaGeralEncomenda(data1, data2, tipoPedido): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GerarControleCaixaGeralEncomenda/${data1}/${data2}/${tipoPedido}`, { headers })
      .toPromise();
  }
  
  


  relatorioTodos(data1, data2): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/relatorioTodos/${data1}/${data2}`, { headers })
      .toPromise();
  }


  relatorioTodosEncomenda(data1, data2): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/relatorioTodosEncomenda/${data1}/${data2}`, { headers })
      .toPromise();
  }

  relatorioTodosClientes(data1, data2): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/relatorioTodosClientes/${data1}/${data2}`, { headers })
      .toPromise();
  }

  

  getDataGerenciar(data1, data2): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GetDataGerenciador/${data1}/${data2}`, { headers })
      .toPromise();
  }

  GetPadraoGerenciador(data, data2, param): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/pegarUltimosTipoGerenciador/${data}/${data2}/${param}`, { headers })
      .toPromise();
  }


  getData(data1, data2): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/GetData/${data1}/${data2}`, { headers })
      .toPromise();
  }


  getById(codigo: any): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/mostrar/${codigo}`, { headers })
      .toPromise();
  }


  GetByNome(text: string): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/pesquisarNome/${text}`, { headers })
      .toPromise();
  }


  
  testepdf(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.pedidoUrl}/testepdf`, { headers })
      .toPromise();
  }
  
  

  excluir(codigo: any): Promise<void> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.delete(`${this.pedidoUrl}/deletar/${codigo}`, { headers })
      .toPromise()
      .then(() => null);
  }


  editarStatuseEntregador(pedido: Pedido): Promise<Pedido> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(pedido);
    return this.http.put(`${this.pedidoUrl}/editarStatuseEntregador`, body, { headers })
      .toPromise()
      .then(response => {
        const pessoaAlterada = response as Pedido;
        return pessoaAlterada;
      });
  }

  save(pedido: Pedido) {
    if (pedido.id) {
      return this.atualizar(pedido);
    } else {
      return this.adicionar(pedido);
    }
  }

  adicionar(pedido: Pedido): Promise<Pedido> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(pedido);
    return this.http.post<Pedido>(`${this.pedidoUrl}/inserir`, body, { headers })
      .toPromise();

  }


  atualizar(pedido: Pedido): Promise<Pedido> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(pedido);
    return this.http.put(`${this.pedidoUrl}/editar`, body, { headers })
      .toPromise()
      .then(response => {
        const pessoaAlterada = response as Pedido;
        return pessoaAlterada;
      });
  }



}
